import {useEffect, useState} from "react";
import {Button, Col, ConfigProvider, Form, Input, message, Row} from "antd";


import styles from '../index.module.less'
import {SFuncModal} from "shj-components";
import {controlPanelSendUpdateMailCode, controlPanelUpdateMail} from "@/services";

interface IProps {
  data: any;
  onClose: (data?: string) => void
}

const EditEmailForm = (props: IProps) => {
  const {onClose} = props;
  let [form] = Form.useForm();

  const [isGetting, setIsGetting] = useState<boolean>(false)
  const [sendCodeLoading, setSendCodeLoading] = useState<boolean>(false)
  const [waitingTime, setWaitingTime] = useState<number>(60)

  useEffect(() => {
    form.resetFields();
  }, []);


  useEffect(() => {
    let timer;
    if (isGetting) {
      timer = setTimeout(() => {
        if (waitingTime > 0) {
          setWaitingTime(waitingTime - 1)
        } else {
          setIsGetting(false)
        }
        timer && clearTimeout(timer)
      }, 1000)
    } else {
      timer && clearTimeout(timer)
      setWaitingTime(60)
    }
  }, [isGetting, waitingTime])


  const onGetCheckCode = () => {
    form.validateFields(['email']).then(() => {
      setSendCodeLoading(true);
      controlPanelSendUpdateMailCode({email: form.getFieldValue('email')})
        .then(() => {
          setIsGetting(true);
          setSendCodeLoading(false);
        })
        .catch(() => {
          setIsGetting(false);
          setSendCodeLoading(false);
        })
    })
  }


  const onFinish = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      form
        .validateFields()
        .then((values) => {
          controlPanelUpdateMail(values).then(() => {
            message.success('操作成功')
            resolve();
            onClose(values.email)
          })
        })
        .catch(reject);
    });
  };

  return (
    <SFuncModal.Content
      okText={'保存'}
      onOk={onFinish}
      onCancel={() => onClose()}
      confirmLoading={false}
    >
      <Form form={form} layout={'vertical'}>
        <Form.Item label={'邮箱'} name={'email'}
               rules={[{required: true, message: '邮箱不能为空'}, {
                 type: 'email',
                 message: '请输入正确的邮箱'
               }]}
        >
          <Input placeholder={'请输入邮箱'} maxLength={50}/>
        </Form.Item>
        <Row>
          <Col span={18}>
            <Form.Item
              name="code"
              label={'验证码'}
              className={styles.mb_0}
              rules={[{required: true, message: '验证码不能为空'}]}
            >
              <Input style={{borderTopRightRadius: 0, borderBottomRightRadius: 0}}
                   placeholder="请输入验证码"/>
            </Form.Item>
          </Col>
          <Col span={6}>
            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    defaultBg: '#fafafa',
                    defaultActiveBg: '#fafafa',
                    defaultHoverBg: '#fafafa',
                    defaultActiveBorderColor: '#d9d9d9',
                    defaultHoverBorderColor: '#d9d9d9',
                    defaultActiveColor: '#000000e0',
                    defaultHoverColor: '#000000e0',
                  },
                },
              }}
            >
              <Button
                className={styles.right_code_btn}
                block
                onClick={onGetCheckCode}
                disabled={isGetting}
                loading={sendCodeLoading}
              >
                {!isGetting ? '获取验证码' : `${waitingTime} s`}
              </Button>
            </ConfigProvider>
          </Col>
        </Row>
      </Form>
    </SFuncModal.Content>);
};

export default EditEmailForm
